import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Routenwächter für angemeldete Benutzer: leitet Abgemeldete zur Anmeldung (mit Rücksprungziel)
 * und Benutzer mit erzwungenem Passwortwechsel zur Seite „Passwort ändern".
 */
export function RequireAuth() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  if (user === undefined) return <p role="status">{t('common.loading')}</p>;
  if (user === null) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.mustChangePassword && location.pathname !== '/passwort-aendern') {
    return <Navigate to="/passwort-aendern" replace />;
  }
  return <Outlet />;
}

/**
 * Routenwächter für Administratoren (innerhalb von `RequireAuth`): andere Benutzer sehen einen
 * Hinweis statt des Bereichs. Die eigentliche Absicherung erfolgt serverseitig (403).
 */
export function RequireAdmin() {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (user?.role !== 'admin') {
    return (
      <section>
        <h1>{t('forbidden.title')}</h1>
        <p>{t('forbidden.body')}</p>
      </section>
    );
  }
  return <Outlet />;
}
